import { Component } from "react";

/** Beklenmeyen hatalarda kullanıcıya teknik ayrıntı değil, hata referans numarası gösterir. */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, reference: "" };
  }

  static getDerivedStateFromError() {
    const reference = `CFT-${Date.now().toString(36).toUpperCase()}`;
    return { failed: true, reference };
  }

  componentDidCatch(error, info) {
    // Teknik ayrıntı yalnızca konsola; kullanıcıya gösterilmez.
    console.error("Ciftora hata referansı", this.state.reference, error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="mx-auto max-w-xl px-4 py-20 text-center" data-testid="error-boundary">
        <img
          src="/brand/ciftora/logo/ciftora-logo-primary.png"
          alt="Ciftora – Çiftliğin Dijital Dünyası"
          className="mx-auto h-14 w-auto object-contain"
        />
        <h1 className="mt-10 font-display text-2xl font-extrabold text-primary sm:text-3xl">
          İşleminiz şu anda tamamlanamadı.
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Lütfen sayfayı yenileyip tekrar deneyin. Sorun sürerse destek ekibimize aşağıdaki hata
          referansıyla ulaşabilirsiniz.
        </p>
        <p className="mt-4 text-sm font-bold text-primary" data-testid="error-reference">
          Hata referansı: {this.state.reference}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            className="inline-flex h-12 items-center rounded-full bg-primary px-6 text-sm font-bold text-primary-foreground"
          >
            Sayfayı Yenile
          </button>
          <a
            href="/"
            data-testid="error-home-btn"
            className="inline-flex h-12 items-center rounded-full bg-secondary px-6 text-sm font-bold text-secondary-foreground"
          >
            Ana Sayfa
          </a>
        </div>
        <p className="mt-6 text-xs text-muted-foreground">destek@ciftora.com</p>
      </div>
    );
  }
}
